/* eslint-disable react/prop-types */
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
// import { GOHONZON_SUBMISSION } from "../../contants/formFields";
// import InputField from "../common/new/InputField/InputField";
import Typography from "../common/new/Typography/Typography";
import styles from "./GohonzonOtherInput.styles";

function GohonzonOtherInput({
  name,
  value,
  preLabel,
  required,
  handleChange,
  readOnly,
  buttonLabels = ["Yes", "No"],
  lableValues = ["YES", "NO"],
  inputStyle,
}) {
  return (
    <Box style={styles.boolInputContainer}>
      <Box style={styles.preLabel}>
        <Typography variant="mini" color="#5e5e5e" weight={600}>
          {preLabel}{" "}
          {required ? (
            <Typography variant="small" color="#FF6A69">
              *
            </Typography>
          ) : (
            ""
          )}
        </Typography>
      </Box>
      <Box style={styles.radioButtons}>
        <FormControl>
          <RadioGroup row name={name} value={value} onChange={handleChange}>
            <FormControlLabel
              value={lableValues[0]}
              control={
                <Radio
                  size="small"
                  disabled={readOnly}
                  // required={required}
                  checked={value === lableValues[0]}
                  sx={inputStyle}
                />
              }
              label={buttonLabels[0]}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: 12,
                },
              }}
            />
            <FormControlLabel
              value={lableValues[1]}
              control={
                <Radio
                  size="small"
                  disabled={readOnly}
                  // required={required}
                  checked={value === lableValues[1]}
                  sx={inputStyle}
                />
              }
              label={buttonLabels[1]}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: 12,
                },
              }}
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
}

export default GohonzonOtherInput;
